module.exports = __webpack_public_path__ + "static/media/getapp-huawei.d645c768.png";